import TextInput from "../textInput/textInput";
import {Visibility, VisibilityOff} from "@mui/icons-material";
import React from "react";
import {ValidatedValue} from "../../../../helpers/validatedValue";

interface PasswordProps {
    password: ValidatedValue<string>;
    label: string;
    testId: string;
}

export default function Password (props: PasswordProps) {
    const [displayPassword, changeDisplayPassword] = React.useState(false);

    return (
        <TextInput
            label={props.label}
            validatedValue={props.password}
            testId={props.testId}
            type={displayPassword ? "text" : "password"}
            endIcon={displayPassword ? <VisibilityOff/> : <Visibility/>}
            offAutocomplete={true}
            onClickEndIcon={() => {
                changeDisplayPassword(!displayPassword);
            }}
        />

    );
}
